import axios from 'axios';
import Instance from './interceptor';
import { API } from '../constants/Constants';
import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
} from './localStorageUtils';
import Toast from '../components/pages/utils/Toast';
import { DOCUMENT_TOAST, USER_TOAST } from '../constants/toastConstant';

export const registerUser = async (data) => {
  try {
    const response = await Instance.post(`${API.REGISTER_USER}`, data);
    const user = await response?.data;
    Toast({ message: `${user?.message}`, variant: 'success' });
    return user;
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};

const localStorageAfterLogin = (user) => {
  setLocalStorageItem('RefreshToken', user?.refreshToken);
  setLocalStorageItem('AccessToken', user?.accessToken);
  setLocalStorageItem('UserId', user?.id);
  setLocalStorageItem('SessionId', user?.sessionId);
  setLocalStorageItem('role', user?.roles[0]);
};

export const loginUser = async (data) => {
  try {
    const { email } = data;
    const { password } = data;

    const response = await axios.post(`${API.LOGIN_USER}`, {
      email,
      password,
    });
    const user = await response?.data;
    if (user?.otp) {
      setLocalStorageItem('otp', user?.otp);
      setLocalStorageItem('OtpExp', user?.otpexp);
      setLocalStorageItem('email', user?.email);
      return user;
    }
    localStorageAfterLogin(user);
    Toast({ message: `${user.message}`, variant: 'success' });
    return user;
  } catch (error) {
    if (error?.response?.status === 400) {
      Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
    } else if (error?.message === 'Network Error') {
      Toast({
        message:
          'Our services are temporarily unavailable. Please try again later.',
        variant: 'error',
      });
    }
  }
};

export const logoutUser = async () => {
  try {
    const refreshToken = getLocalStorageItem('RefreshToken');
    const sessionId = getLocalStorageItem('SessionId');

    const response = await Instance.post(`${API.LOGOUT_USER}`, {
      refreshToken,
      sessionId,
    });
    const logoutData = response?.data;

    if (response && logoutData) {
      removeLocalStorageItem('RefreshToken');
      removeLocalStorageItem('AccessToken');
      removeLocalStorageItem('UserId');
      removeLocalStorageItem('otp');
      removeLocalStorageItem('OtpExp');
      removeLocalStorageItem('email');
      removeLocalStorageItem('SessionId');
      removeLocalStorageItem('role');

      if (response?.status === 200 && logoutData?.message) {
        Toast({ message: `${logoutData?.message}`, variant: 'success' });
      }
    }
    return logoutData;
  } catch (error) {
    if (!(error && error.status === 419)) {
      Toast({ message: `${error?.message}`, variant: 'error' });
    }
  }
};

// export const deleteUser = async (_id) => {
//   try {
//     const response = await axios.delete(
//       `http://192.168.2.79:8999/users/delete/${_id}`
//     );
//     const user = await response?.data;

//     if (!user) {
//       Toast({ message: `${user.toastMsg}`, variant: "error" });
//     } else {
//       Toast({ message: `${user.toastMsg}`, variant: "success" });
//       return user;
//     }
//   } catch (error) {
//     Toast({ message: `${error?.message}`, variant: "error" });
//   }
// };

export const updateUserDetails = async (data) => {
  const { formDataUserDetails, config } = data;
  try {
    const response = await Instance.patch(
      `${API.UPDATE_USER}`,
      formDataUserDetails,
      {
        headers: config,
      },
    );
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.error}`, variant: 'error' });
  }
};

export const getLoggedInUserDetail = async () => {
  try {
    const response = await Instance.get(`${API.LOGGED_USER}`);
    if (!response) {
      return null;
    }
    return response?.data?.user;
  } catch (error) {
    if (error?.name === 'AxiosError') {
      Toast({ message: `${error?.message}`, variant: 'error' });
    } else if (error?.response?.data?.message) {
      Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
    }
  }
};

export const getMembers = async () => {
  try {
    const members = await Instance.post(`${API.GET_MEMBERS}`);
    if (!members) {
      return null;
    }
    return {
      member: members?.data?.users?.Members,
      payment: members?.data?.organization?.payment,
    };
  } catch (error) {
    if (error?.name === 'AxiosError') {
      Toast({ message: `${error?.message}`, variant: 'error' });
    } else if (error?.response?.data?.message) {
      Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
    }
  }
};

export const getMembersForGird = async (
  sorting,
  inputValue,
  filterModel,
  dropDownValue,
  organizationId,
) => {
  try {
    const data = {
      sorting,
      filterModel,
      // sortOrder: sorting[0]?.sort,
      // // sortField: sorting[0]?.colId,
      country: false,
      status: false,
      role: false,
      organizationId,
    };
    const members = await Instance.post(`${API.GET_MEMBERS}`, data);
    if (members?.data?.users?.Members?.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return members?.data?.users?.Members;
    }
    return members?.data?.users?.Members;
  } catch (error) {
    console.log(error);

    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const getMemberById = async (id) => {
  try {
    const member = await Instance.get(`${API.USER_BY_ID}/${id}`);
    if (!member) {
      return null;
    }
    return member?.data?.user;
  } catch (error) {
    Toast({ message: `${error?.response?.data}`, variant: 'error' });
  }
};

export const activateMember = async (id, activeState) => {
  const data = {
    is_active: activeState,
  };
  try {
    const response = await Instance.patch(`${API.ACTIVATE_MEMBER}/${id}`, data);
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response;
    }
    return Toast({
      message: `${response?.data?.message}`,
      variant: 'error',
    });
  } catch (error) {
    Toast({ message: `${error?.response?.data}`, variant: 'error' });
  }
};

export const loginActivity = async (
  sorting,
  inputValue,
  filterModel,
  organizationId,
) => {
  try {
    const data = {
      searchData: inputValue,
      filterModel,
      sortOrder: sorting[0]?.sort,
      sortField: sorting[0]?.colId,
      organizationId,
    };
    const response = await Instance.post(`${API.ACTIVITY_HISTORY}`, data);
    const userActivityHistory = response?.data?.activityHistory;
    if (userActivityHistory?.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return userActivityHistory;
    }
    return userActivityHistory;
  } catch (error) {
    Toast({
      message: `${error?.message}`,
      variant: 'error',
    });
  }
};

export const activityHistory = async (data) => {
  try {
    const response = await Instance.post(`${API.GET_ACTIVITY_LOGS}`, data);
    if (response?.data.data.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return response?.data;
    }
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const rootAdminLoginActivity = async (
  sorting,
  inputValue,
  filterModel,
  filterValue,
  data,
  page,
) => {
  try {
    const PAGE_LIMIT = 25;
    const payload = {
      searchData: inputValue,
      filterModel,
      sortOrder: sorting[0]?.sort,
      sortField: sorting[0]?.colId,
      page,
      limit: PAGE_LIMIT,
    };
    const response = await Instance.post(
      `${API.ROOT_ADMIN_ACTIVITY_HISTORY}`,
      payload,
    );
    if (response?.data?.activityHistory?.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return response?.data?.activityHistory;
    }
    return response?.data?.activityHistory;
  } catch (error) {
    Toast({
      message: `${error?.message}`,
      variant: 'error',
    });
  }
};

export const deleteUser = async (id) => {
  try {
    const response = await Instance.delete(`${API.DELETE_USER}/${id}`);
    if (response) {
      Toast({ message: USER_TOAST.USER_DELETE, variant: 'success' });
      return response;
    }
  } catch (error) {
    if (error?.response?.data) {
      Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
    } else {
      Toast({
        message: `${error?.message}`,
        variant: 'error',
      });
    }
  }
};

export const getAdminDetails = async (organizationId) => {
  try {
    const data = {
      organizationId,
    };
    const response = await Instance.post(`${API.ADMIN_DETAILS}`, data);
    if (response) {
      return response.data.adminDetail;
    }
  } catch (error) {
    return error;
  }
};

export const getSubscriptionDetails = async (organizationId) => {
  try {
    const data = {
      organizationId,
    };
    const response = await Instance.post(
      `${API.GET_SUBSCRIPTION_DETAILS}`,
      data,
    );
    if (response) {
      return response.data;
    }
  } catch (error) {
    return error;
  }
};
export const createOrUpdateSubscription = async (
  organizationId,
  planId,
  status,
) => {
  try {
    const data = {
      organizationId,
      planId,
      status,
    };
    const response = await Instance.post(
      `${API.CREATE_OR_UPDATE_SUBSCRIPTION_DETAILS}`,
      data,
    );
    if (response) {
      return response.data;
    }
  } catch (error) {
    return error;
  }
};

export const getPricingPlanDetails = async (planId) => {
  try {
    const data = {
      planId,
    };
    const response = await Instance.post(
      `${API.GET_PRICING_PLAN_DETAILS}`,
      data,
    );
    if (response?.status === 200) {
      return response;
    }
  } catch (error) {
    return error;
  }
};

export const getAllPricingPlanDetails = async () => {
  try {
    const response = await Instance.get(`${API.GET_ALL_PRICING_PLAN_DETAILS}`);
    if (response) {
      return response.data;
    }
  } catch (error) {
    return error;
  }
};

export const getAdminActivityHistory = async () => {
  try {
    const data = await Instance.get(API.ADMIN_ACTIVITY_HISTORY);
    const { adminActivityHistory } = data.data;
    if (!adminActivityHistory) {
      return [];
    }
    return adminActivityHistory;
  } catch (error) {
    return error;
  }
};

export const getActivityHistory = async (data) => {
  try {
    const response = await Instance.post(`${API.GET_ACTIVITY_LOGS}`, data);
    if (response?.data.data.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return response?.data;
    }
    return response.data;
  } catch (error) {
    return error;
  }
};
